// @flow
import * as React from "react"

import s from "./Static.scss"

export default ({ children }: { children: React.Node }) => <div className={s.container}>{children}</div>
